import styled, { css } from "styled-components";
import { rem } from "polished";

const El = styled.span`
  position: absolute;
  top: 0;
  font-weight: 800;
  font-size: ${rem(10)};
  line-height: 1.5;
  text-transform: uppercase;
  font-family: Sans-serif;
  border: 1px solid;
  padding: 0 ${rem(6)};
  border-radius: 3px;
  left: ${rem(13)};
  transform: translateY(-50%);
  background: #fff;
  box-shadow: 2px 0px 0px 0px #fff, -2px 0px 0px 0px #fff;

  ${({ type }) =>
    type === "essential" &&
    css`
      color: red;
    `}

  ${({ type }) =>
    type === "recommended" &&
    css`
      color: #ad8f4c;
    `}

    ${({ type }) =>
    type === "most-popular" &&
    css`
      color: #CC6F4C;
    `}
`;

const Label = ({ type, text }) => <El type={type}>{text}</El>;

export default Label;
